var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRadiocallingpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.6406 0 0.716094 18.6094 0.00325 40L0 48.3125C0 54.7656 5.11719 60 11.4281 60H14.2859C17.4375 60 20 57.3906 20 54.1562V33.3438C20 30.1094 17.4375 27.5 14.2859 27.5H11.4281C10.9161 27.5 10.4369 27.6117 9.94406 27.6794C14.8125 15.8594 26.4531 7.53125 40 7.52969C53.5531 7.53152 65.1875 15.8672 70.0625 27.5453C69.5625 27.6094 69.0781 27.5 68.5781 27.5H65.7203C62.5625 27.5 60 30.1094 60 33.3438V54.1562C60 57.3906 62.5625 60 65.7188 60H68.5766C69.9633 60 71.275 59.7092 72.5047 59.2469V62.5C72.5047 65.9469 69.7016 68.75 66.2547 68.75H48.9578C47.6562 66.5156 45.2656 65 42.5 65H37.5C33.3594 65 30 68.3594 30 72.5C30 76.6406 33.3594 80 37.3594 80H42.5C45.2687 80 47.6609 78.4827 48.9594 76.25H66.25C73.8328 76.25 80 70.0828 80 62.5V40C79.2812 18.6094 62.3594 0 40 0ZM11.4281 35H12.5V52.5H11.4281C9.2625 52.5 7.5 50.4844 7.5 48.3125V40C7.5 39.6234 7.54364 39.2578 7.55645 38.8842C7.70781 36.7188 9.36094 35 11.4281 35ZM68.5781 52.5H67.5V35H68.5714C70.6386 35 72.2917 36.725 72.4433 38.8844C72.4531 39.2656 72.5 39.625 72.5 40V48.3187C72.5 50.4844 70.7344 52.5 68.5781 52.5Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiocallingpoint);
export default __webpack_public_path__ + "static/media/radiocallingpoint.1e141b91387e5fdc47b27ffdfc0a3636.svg";
export { ForwardRef as ReactComponent };